import { render } from "./EditCustomer.vue?vue&type=template&id=0022abd3&scoped=true"
import script from "./EditCustomer.vue?vue&type=script&lang=js"
export * from "./EditCustomer.vue?vue&type=script&lang=js"

import "./EditCustomer.vue?vue&type=style&index=0&id=0022abd3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0022abd3"]])

export default __exports__